const { useState } = React;

function ClientPage() {
    const [selectedFilter, setSelectedFilter] = useState('all');

    return (
        <div className="w-full bg-white">
            {/* Navigation */}
            <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-blue-100/20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-16">
                        <a href="#home" className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent">
                            Rent Deck
                        </a>
                        <div className="flex gap-4">
                            <a href="#home" className="px-4 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium">
                                Home
                            </a>
                            <a href="#agent" className="px-4 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium">
                                Switch to Agent
                            </a>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Hero Section */}
            <section className="relative pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
                <div className="max-w-6xl mx-auto text-center">
                    <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-6">
                        Find Your Perfect Home
                    </h1>
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-12">
                        Browse thousands of verified listings and book viewings in seconds. Your dream property is just a few clicks away.
                    </p>
                </div>
            </section>

            {/* Search & Filter Section */}
            <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white border-b border-blue-100">
                <div className="max-w-6xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
                        <input
                            type="text"
                            placeholder="Location"
                            className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
                        />
                        <select className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600">
                            <option>All Property Types</option>
                            <option>Apartment</option>
                            <option>House</option>
                            <option>Condo</option>
                        </select>
                        <select className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600">
                            <option>All Prices</option>
                            <option>Under $1,000</option>
                            <option>$1,000 - $2,000</option>
                            <option>$2,000+</option>
                        </select>
                        <button className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-lg hover:shadow-lg hover:shadow-blue-500/50 transition-all font-semibold">
                            Search
                        </button>
                    </div>

                    {/* Filter Tabs */}
                    <div className="flex gap-3 overflow-x-auto">
                        {['All Properties', 'Featured', 'New Listings', 'Open Today'].map((filter, index) => (
                            <button
                                key={index}
                                onClick={() => setSelectedFilter(filter)}
                                className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-all ${selectedFilter === filter ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                            >
                                {filter}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Properties Grid */}
            <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
                <div className="max-w-6xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {[1, 2, 3, 4, 5, 6].map((property) => (
                            <div key={property} className="group rounded-2xl overflow-hidden border border-blue-100 hover:border-blue-300 transition-all hover:shadow-xl hover:shadow-blue-500/10">
                                {/* Image */}
                                <div className="relative h-56 bg-gradient-to-br from-blue-100 to-blue-50 overflow-hidden">
                                    <div className="w-full h-full flex items-center justify-center text-6xl">🏠</div>
                                    <div className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                                        For Rent
                                    </div>
                                </div>

                                {/* Details */}
                                <div className="p-6">
                                    <div className="flex justify-between items-start mb-2">
                                        <h3 className="text-xl font-bold text-gray-900">Modern 3BR Apartment</h3>
                                        <span className="text-2xl">⭐</span>
                                    </div>
                                    <p className="text-gray-600 text-sm mb-4">Lekki, Lagos • 2,200 sqft</p>

                                    {/* Price */}
                                    <div className="mb-4">
                                        <p className="text-3xl font-bold text-blue-600">₦4.5M</p>
                                        <p className="text-sm text-gray-600">/month or per viewing</p>
                                    </div>

                                    {/* Features */}
                                    <div className="grid grid-cols-3 gap-2 mb-6 text-sm text-gray-700">
                                        <div className="text-center">
                                            <div className="font-bold">3</div>
                                            <div>Bedrooms</div>
                                        </div>
                                        <div className="text-center">
                                            <div className="font-bold">3</div>
                                            <div>Bathrooms</div>
                                        </div>
                                        <div className="text-center">
                                            <div className="font-bold">Verified</div>
                                            <div>Listing</div>
                                        </div>
                                    </div>

                                    {/* Button */}
                                    <button className="w-full px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-lg hover:shadow-lg hover:shadow-blue-500/50 transition-all font-semibold">
                                        View & Book
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-4xl font-bold text-gray-900 mb-6">Ready to Find Your Home?</h2>
                    <p className="text-xl text-gray-600 mb-8">Join thousands of happy renters using Rent Deck</p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <button className="px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-lg hover:shadow-lg hover:shadow-blue-500/50 transition-all font-semibold">
                            Start Browsing Now
                        </button>
                        <a href="#home" className="px-8 py-4 border-2 border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition-all font-semibold">
                            Back Home
                        </a>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default ClientPage;
